import React, { useEffect, useState } from "react";
import { Row, Col, Form, Input, message, Space, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import usePost from "../../services/usePost";
import useGetApi from "../../services/useGetApi";

const AddSection = ({ addSectionBtn, setAddSectionBtn, title,sectionEditId,
  getSections
 }) => {
  const [form] = Form.useForm();
  const [section, setSection] = useState("");
  const [editSection,setEditSection] = useState()
  const { id } = useParams();

  // useEffect(() => {
  //   console.log(editId,'.........................................')
  // },[editId])

  const [isPostLoading, postError, postData] = usePost();
    const [
        sectionsIsLoading,
        sectionsError,
        sectionData,
        getEditSections,
      ] = useGetApi(`sections/${sectionEditId}`, [], true)

  
      useEffect(() => {
        getEditSections(`sections/${sectionEditId}`)
      },[sectionEditId])

      useEffect(() => {
        if(sectionData){
         setEditSection(sectionData)
        } 

        form.setFieldsValue({
          title:sectionData?.title
        })
      },[sectionData])

  const onFinish = async (values) => {
   
    const data = {
      "courseId": id,
      "endDate": "2025-12-31",
      "orders": 1,
      "restrictedBy": "none",
      "startDate": "2025-12-31",
      "title": values.title
    }

    const updateSection = {
      ...editSection,  
      title: values.title, 
    }


     if(sectionEditId){
      console.log('calling')
      const response = await postData(`sections`,updateSection,true)
      if(response){
        console.log('success')
        setAddSectionBtn(false)
        getSections(`course/details/${id}`)
       }
     }
     else{
      const response = await postData(`sections`,data,true)
      if(response){
        // console.log('success')
        setAddSectionBtn(false)
        getSections(`course/details/${id}`)
       }
     }
  };

  const onFinishFailed = () => {
    message.error("Submit failed! Please check the form.");
  };



  return (
    <>
      {addSectionBtn && (
        <div className="popup-overlay">
          <div className="addsection-container p-20">
            <Row gutter={16}>
              <Col span={12}>
                <p>{title}</p>
              </Col>
              <Col span={12}>
                <button
                  className="close-btn"
                  onClick={() => setAddSectionBtn(false)}
                >
                  <CloseOutlined />
                </button>
              </Col>
            </Row>
            <Row className="popup_horizontal_line"></Row>

            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                label="Title"
                name="title" 
                rules={[{ required: true, message: "Please input the section title!" }]}
              >
                <Input
                  // onChange={(e) => setSection(e.target.value)}
                  placeholder="Enter section title"
                />
              </Form.Item>
              <Form.Item>
                <Space>
                  <Row className="submit_btn_div">
                    <button
                      className="popup_submit_btn"
                        htmlType="submit"
                      // loading={isPostLoading} 
                    >
                      Submit
                    </button>
                  </Row>
                </Space>
              </Form.Item>
            </Form>
{/* 
            <Row className="popup_horizontal_line"></Row>
            <Row className="back_btn_div mt-10">
              <button
                className="popup_back_btn"
                type="button"
                onClick={() => setAddSectionBtn(false)}
              >
                Back
              </button>
            </Row> */}
          </div>
        </div>
      )}
    </>
  );
};

export default AddSection;
